import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import eu.bontlab.pages.HomePage as _eu_bontlab_pages_HomePage

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Bontlab"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register(
            "/",
        ) { pageCtx -> 
            _eu_bontlab_pages_HomePage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("about-image", eu.bontlab.styles.AboutImageStyle)
        ctx.theme.registerStyle("about-text", eu.bontlab.styles.AboutTextStyle)
        ctx.theme.registerStyle("back-to-top-button", eu.bontlab.styles.BackToTopButtonStyle)
        ctx.theme.registerStyle("input", eu.bontlab.styles.InputStyle)
        ctx.theme.registerStyle("navigation-item", eu.bontlab.styles.NavigationItemStyle)
        ctx.theme.registerStyle("logo", eu.bontlab.styles.LogoStyle)
        ctx.theme.registerStyle("social-link", eu.bontlab.styles.SocialLinkStyle)
        ctx.theme.registerStyle("main-button", eu.bontlab.styles.MainButtonStyle)
        ctx.theme.registerStyle("main-image", eu.bontlab.styles.MainImageStyle)
        ctx.theme.registerStyle("portfolio-section", eu.bontlab.styles.PortfolioSectionStyle)
        ctx.theme.registerStyle("portfolio-arrow-icon", eu.bontlab.styles.PortfolioArrowIconStyle)
        ctx.theme.registerStyle("service-card", eu.bontlab.styles.ServiceCardStyle)
        eu.bontlab.initStyles(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        eu.bontlab.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
